import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class EmptyNavigationModel implements FuseNavigationModelInterface {
    public model: any[];

    constructor() {
        this.model = [
            {            
            },
        ];
    }
}




// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/navigation/emptyNavigation.model.ts